import { render, staticRenderFns } from "./about-us.component.vue?vue&type=template&id=b15519b0&"
import script from "./about-us.component.ts?vue&type=script&lang=ts&"
export * from "./about-us.component.ts?vue&type=script&lang=ts&"
import style0 from "./about-us.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports